export default "__VITE_ASSET__EeqHnXCv__"